import { cloneDeep } from 'lodash-es';
import { IClimateCortexModelService } from './ccc.model.abstract';
import { IStock } from '../../model/stock';
import { IGlobalExternality } from '../../model/global-externality';
import { ClimateCortexModelInitializerService } from '../../../climate-cortex-model-initializer.service';
import { IVariable } from '../../model/variable';
import { ITransitionElement } from '../../model/transition-element';
import { ICarbonCausalChain } from '../../model/carbon-causal-chain';
import { IResource } from '../../model/resource';

export interface ClimateCortexModel {
  transitionElements: {
    [key: string]: ITransitionElement;
  };
  carbonCausalChains: {
    [key: string]: ICarbonCausalChain;
  };
  resources: {
    [key: string]: IResource;
  };
  variables: {
    [key: string]: IVariable;
  };
  stocks: {
    [key: string]: IStock;
  };
  globalExternalities: {
    [key: string]: IGlobalExternality;
  };
}

export class ClimateCortexModelService implements IClimateCortexModelService {
  get carbonCausalChains() {
    return cloneDeep(this._model.carbonCausalChains);
  }

  get variables() {
    return cloneDeep(this._model.variables);
  }

  get resources() {
    return cloneDeep(this._model.resources);
  }

  get transitionElements() {
    return cloneDeep(this._model.transitionElements);
  }

  get stocks() {
    return cloneDeep(this._model.stocks);
  }

  get globalExternalities() {
    return cloneDeep(this._model.globalExternalities);
  }

  private _model: ClimateCortexModel;
  constructor(private _ccModelInitService: ClimateCortexModelInitializerService) {
    this._model = this._ccModelInitService.model;
  }
}
